export default __webpack_public_path__ + "static/media/licensing-heading-mobile.5709330a.jpg";